import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const BasicPrice = ({ label, amount, currency = "USD" }) => {
  return (
    <div className="flex items-center justify-between">
      <span>{label}</span>
      <span className="text-lg font-semibold text-gray-600">
        {formatCurrencyFromMinorUnits({ amount, currency })}
      </span>
    </div>
  )
}

BasicPrice.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string,
}

export default BasicPrice
